import React, { useState } from 'react';
import './HelpTrigger.css';
import { FaPhone, FaComments, FaCalendarAlt, FaQuestionCircle } from 'react-icons/fa';

const HelpTrigger = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <div className="help-trigger-container">
      <button className="help-main-button" onClick={toggleMenu}>
        <FaQuestionCircle /> {isOpen ? 'Close' : 'Need Help?'}
      </button>

      {isOpen && (
        <div className="help-options">
          <a href="tel:+911234567890" className="help-option">
            <FaPhone /> Call Us
          </a>
          <a href="#" className="help-option">
            <FaComments /> Chat with Us
          </a>
          <a href="#" className="help-option">
            <FaCalendarAlt /> Book a Design CTA
          </a>
        </div>
      )}
    </div>
  );
};

export default HelpTrigger;
